/* eslint-disable */
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import LoadingButton from '@mui/lab/LoadingButton';
import { alpha, useTheme, styled } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import Divider from '@mui/material/Divider';

import { Alert, Button, Fade, Modal, Grid, Dialog, DialogTitle, DialogContentText, DialogActions, DialogContent } from '@mui/material';
import { MuiOtpInput } from 'mui-one-time-password-input';
import { apiUrl,  postRequest } from '../utils/services';
import { bgGradient } from '../theme/css';
import Logo from '../components/logo';
import Iconify from '../components/iconify';
import { AuthContext } from '../context/AuthContext';



let timerId
export default function RegisterPage() {

  const theme = useTheme();

  const [buttonLoad, setButtonLoad] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);
  const [otpError, setOtpError] = useState('');
  const [otp, setOtp] = useState('');
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [registerInputError, setRegisterInputError] = useState({ username: '', firstName: '', lastName: '', email: '', mobileNumber: '', confirmPassword: '', password: '' });
  const { registerInfo, updateRegisterInfo, registerUser, setToats, setRegisterError } = useContext(AuthContext);
  const [timeRemaining, setTimeRemaining] = useState(0); // 10 minutes in seconds

  const resendBtnRef = useRef(null);
  const handleClose = () => setOpen(false);

  const handleChange = (newValue) => {
    setOtp(newValue)
  }

  const formatTime = (seconds) => {
    if (seconds <= 0) {
      clearInterval(timerId)
      // setTimeRemaining(1*5)
      // setResendButton(false)
      return '';
    }
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `in ${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')} sec`;
  };


  const validateUsername = (name) => {
    const alphanumericRegex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/;
    if (name.length < 8) {
      return 'Username must be at least 8 characters long';
    } else if (!alphanumericRegex.test(name)) {
      return 'Username must contain both alphabetic and numeric characters';
    }
    return '';
  };

  const validateInputs = () => {
    const errors = {};

    if (!registerInfo.firstName) {
      errors.firstName = 'First Name is required';
    }
    if (!registerInfo.lastName) {
      errors.lastName = 'Last Name is required';
    }
    const usernameError = validateUsername(registerInfo.userName);
    if (usernameError) {
      errors.username = usernameError;
    }
    if (!registerInfo.email) {
      errors.email = 'Email address is required';
    }
    if (!registerInfo.mobileNumber) {
      errors.mobileNumber = 'Mobile Number is required';
    }
    if (!registerInfo.password) {
      errors.password = 'Password is required';
    }
    if (!confirmPassword) {
      errors.confirmPassword = 'Confirm Password is required';
    } else if (registerInfo.password !== confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }

    setRegisterInputError(errors);
    return Object.keys(errors).length === 0;
  };


  const handleRegister = async (e) => {
    e.preventDefault();
    clearInterval(timerId)
    setTimeRemaining(1 * 300)
    setButtonLoad(true)

    if (validateInputs()) {
      try {
        const response = await postRequest(`${apiUrl}/users/getOtp`, JSON.stringify({ registerInfo }));
        console.log(response);
        
        if (response?.error) {
          setButtonLoad(false);
          if (response?.message!={}) {
            
            setToats({
              message: response?.message?.error ?? response?.message??'Somthing Is wrong',
              open: true,
              type: 'error'
            })
          }
          return;
        }
      } catch (error) {
        console.error('Error send OTP:', error);
        setToats({
            message: error,
            open: true,
            type: 'error'
        })
        return
      }
    }
    else {
      setButtonLoad(false);
      return 
    }
    setToats({
      message: "OTP Sent to your email",
      open: true,
      type: 'success'
    })
    setButtonLoad(false);
    setOtp('');
    setOtpError('');
    setRegisterError('');
    setOpen(true);

    timerId = setInterval(() => {
      setTimeRemaining((prevTime) => prevTime - 1);
    }, 1000);
  }

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await postRequest(`${apiUrl}/users/verifyOtp`, JSON.stringify({ email: registerInfo.email, otp }));
      if (response && response.success) {
        setOpen(false);
        clearInterval(timerId)
        registerUser(); // Call the function to register the user
      } else {
        setOtp('');
        setOtpError('Invalide OTP');
      }
    } catch (error) {
      // Handle error
      console.error('Error verifying OTP:', error);
    }
  }

  const renderForm = (
    <form action="" onSubmit={handleRegister}>
      <Box sx={{ overflowY: 'auto' }}>
        <Grid container marginBottom={3} spacing={2}>
          <Grid item sm={6} xs={12} md={6} >
            <Box flex={1} pt={1} >
              <TextField sx={{ width: '100%' }} name="firstName" error={!!registerInputError.firstName} helperText={registerInputError.firstName} label="First Name" value={registerInfo?.firstName} onChange={((e) => updateRegisterInfo({ ...registerInfo, firstName: e.target.value }))} />
            </Box>
          </Grid>
          <Grid item sm={6} xs={12} md={6} >
            <Box flex={1} >
              <TextField sx={{ width: '100%' }} name="lastName" error={!!registerInputError.lastName} helperText={registerInputError.lastName} label="Last Name" value={registerInfo?.lastName} onChange={((e) => updateRegisterInfo({ ...registerInfo, lastName: e.target.value }))} />
            </Box>
          </Grid>
          <Grid item sm={6} xs={12} md={6} >
            <Box flex={1} >
              <TextField sx={{ width: '100%' }} name="userName" error={!!registerInputError.username} helperText={registerInputError.username} label="Username" value={registerInfo?.userName} onChange={((e) => updateRegisterInfo({ ...registerInfo, userName: e.target.value }))} />
            </Box>
          </Grid>

          <Grid item sm={6} xs={12} md={6} >
            <Box flex={1} >
              <TextField sx={{ width: '100%' }} name="email" error={!!registerInputError.email} helperText={registerInputError.email} label="Email address" value={registerInfo?.email} onChange={((e) => updateRegisterInfo({ ...registerInfo, email: e.target.value }))} />
            </Box>
          </Grid>

          <Grid item sm={6} xs={12} md={6} >
            <Box flex={1} >
              <TextField sx={{ width: '100%' }} name="mobileNumber" error={!!registerInputError.mobileNumber} helperText={registerInputError.mobileNumber} label="Mobile Number" value={registerInfo?.mobileNumber} onChange={((e) => updateRegisterInfo({ ...registerInfo, mobileNumber: e.target.value }))} />
            </Box>
          </Grid>
        </Grid>
        <Divider />
        <Grid container marginTop={1} marginBottom={3} spacing={2}>

          <Grid item sm={6} xs={12} md={6} >
            <Box flex={1} >
              <TextField
                name="password"
                sx={{ width: '100%' }}
                error={!!registerInputError.password} helperText={registerInputError.password}
                label="Password"
                value={registerInfo?.password}
                onChange={((e) => updateRegisterInfo({ ...registerInfo, password: e.target.value }))}
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

            </Box>
          </Grid>
          <Grid item sm={6} xs={12} md={6} >
            <Box flex={1} >
              <TextField
                name="confirmPassword"
                label="Confirm Password"
                error={!!registerInputError.confirmPassword} helperText={registerInputError.confirmPassword}
                sx={{ width: '100%' }}
                onChange={(e) => setConfirmPassword(e.target.value)}
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Grid>
        </Grid>


        <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ my: 3 }}>
          {/* <Link variant="subtitle2" href="/forgot-password" underline="hover">
                    Forgot password?
                </Link> */}
        </Stack>

        {/* {registerError && (
        <Alert variant="danger" style={{ color: "red" }}><p>{registerError}</p></Alert>
      )} */}

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          color="inherit"
          onClick={handleRegister}
          loading={buttonLoad}

        >
          Register
        </LoadingButton>
      </Box>
    </form>
  );

  return (
    <>
      <Box
        sx={{
          ...bgGradient({
            color: alpha(theme.palette.background.default, 0.9),
            imgUrl: '/assets/background/overlay_4.jpg',
          }),
          height: 1,
        }}
      // style={{ height: "100vh", overflowY: "scroll" }}
      >
        <Box sx={{ p: 2 }}>
          <Logo />
        </Box>

        <Stack alignItems="center" justifyContent="center" p={2} pt={0} >
          <Card
            sx={{
              p: 5,
              width: 1,
              maxWidth: 620,
            }}
          >
            <Typography variant="h4">Sign Up to Chat</Typography>
            <Typography variant="body2" sx={{ mt: 2, mb: 3 }}>
              already have an account?
              <Link href="/chat/login" variant="subtitle2" sx={{ ml: 0.5 }}>
                Login
              </Link>
            </Typography>

            {renderForm}

          </Card>
        </Stack>
        <Dialog
          open={open}
          fullWidth
          maxWidth='sm'
          onClose={handleClose}
        >
          <DialogTitle id="alert-dialog-title" sx={{pr:'10px'}}>
            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
              Verify Your Email
              <IconButton type="button" onClick={handleClose} aria-label="search">
                <Iconify icon="mdi:close-circle" />
              </IconButton>
            </Stack>
           
          </DialogTitle>
          <DialogContent>
            <DialogContentText >
              OTP has been sent to your email address. Please check your email and enter the OTP below to verify.
            </DialogContentText>
            <MuiOtpInput value={otp} onChange={handleChange} style={{ paddingTop: "10px" }} />
            <Typography variant="body2" ml={1} sx={{ color: 'red' }}>{otpError}</Typography>
          </DialogContent>
          <DialogActions
            sx={{ padding: 3 }}
          >
            <Box>

            <Stack direction='row' justifyContent='space-between'>
              <Button ref={resendBtnRef} sx={{ mt: 1 }} disabled={formatTime(timeRemaining) !== ''} onClick={handleRegister}>Resend OTP {formatTime(timeRemaining)}</Button>
              <Button variant="outlined" onClick={handleOtpSubmit}>Submit</Button>
            </Stack>
            <Typography id="transition-modal-title" color='red' variant="caption">This window will remain open until your email is verified.</Typography>
            </Box>
          </DialogActions>
        </Dialog>
        {/* <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          disableBackdropClick
          closeAfterTransition
        >
          <Fade in={open}>
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, maxWidth: 400 }}>
              <IconButton sx={{ position: 'absolute', top: 0, right: 0 }} onClick={handleClose}>
                <Iconify icon="bi:x" /> 
              </IconButton>
              <Typography id="transition-modal-title" variant="h6">Verify Your Email</Typography>
              <Typography id="transition-modal-title" variant="caption">OTP has been sent to your email address. Please check your email and enter the OTP below to verify.</Typography>
              <MuiOtpInput value={otp} onChange={handleChange} style={{ padding: "10px" }} />
              <Typography variant="body2" ml={1} mb={2} sx={{ color: 'red' }}>{otpError}</Typography>
              <Stack direction='row' justifyContent='space-between'>
                <Button variant="outlined" onClick={handleOtpSubmit}>Submit</Button>
                <Button ref={resendBtnRef} sx={{ mt: 1 }} disabled={formatTime(timeRemaining) !== ''} onClick={handleRegister}>Resend OTP {formatTime(timeRemaining)}</Button>
              </Stack>
              <Typography id="transition-modal-title" color='red' variant="caption">This window will remain open until your email is verified.</Typography>

            </Box>
          </Fade>
        </Modal> */}
      </Box>
    </>
  )
} 